import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(source, true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(source)).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import types from 'prop-types';
import { behaviourTypes } from './behaviour';
import { noop } from 'lodash';
export var TEXT = 'text';
export var EMAIL = 'email';
export var PASSWORD = 'password';
export var PHONE = 'tel';
export var NUMBER = 'number';
export var DECIMAL = 'decimal';
export var SEARCH = 'search';
export var DATE = 'date';
export var URL = 'url';
export default {
  propTypes: _objectSpread({}, behaviourTypes, {
    uncontrolled: types.bool,
    type: types.oneOf([TEXT, EMAIL, PASSWORD, PHONE, NUMBER, DECIMAL, SEARCH, DATE, URL]),
    name: types.string.isRequired,
    disabled: types.bool,
    tabIndex: types.number,
    debounce: types.number,
    placeholder: types.string,
    prefix: types.node,
    suffix: types.node,
    onChange: types.func,
    onFocus: types.func,
    onBlur: types.func,
    setRef: types.func,
    Container: types.elementType,
    Input: types.elementType,
    containerProps: types.object,
    styles: types.oneOfType([types.func, types.object]),
    children: types.node,
    charLimit: types.number,
    showCharLimit: types.bool
  }),
  defaultProps: {
    type: TEXT,
    disabled: false,
    tabIndex: 0,
    placeholder: '',
    onChange: noop,
    debounce: 0,
    onFocus: noop,
    onBlur: noop,
    setRef: noop,
    Container: 'label',
    Input: 'input',
    containerProps: {},
    charLimit: null,
    showCharLimit: false
  }
};